export default class ChapterHubEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

ChapterHubEvent.DESTROY = "ChapterHubEvent.DESTROY";
ChapterHubEvent.SHOW = "ChapterHubEvent.SHOW";
ChapterHubEvent.HIDE = "ChapterHubEvent.HIDE";